export const FIELD_MAPPINGS = {
  a: 'localAccount',
  b: 'localAccountDescription',
  c: 'r2rAccount',
};

export const VALIDATION_ERRORS = {
  WORKSHEET_WIDTH: 'Invalid import file. File must have three columns.',
};
